module.exports = __webpack_public_path__ + "static/media/Avatar_5.4dbe088c.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/Avatar_5.mp4
 ** module id = 632
 ** module chunks = 0
 **/